import { DataStoreUpdateModel } from '@osos/shared/types';

// tslint:disable-next-line: no-namespace
export namespace DataStoreActions {
  /**
   *
   */
  export class UpdateEntityStore {
    static readonly type = '[Entity] Update Entity Store';
    constructor(
      public entityId: string,
      public storeId: string,
      public store: DataStoreUpdateModel,
    ) {}
  }

  export class CreateEntityStore {
    static readonly type = '[Entity] create Entity shared Store';
    constructor(
      public entityId: string,
      public store: DataStoreUpdateModel,
    ) {}
  }

  export class FetchEntityStore {
    static readonly type = '[Entity] fetch Entity Store';
    constructor(
      public entityId: string,
      public storeId: string,
    ) {}
  }
  export class FetchEntityStores {
    static readonly type = '[Entity] fetch Entity Store';
    constructor(public entityId: string) {}
  }
}
